import { Orientation } from '../../../../../../dto'

export const defaultSize = {
  [Orientation.portrait]: { width: 2499, height: 3500 },
  [Orientation.landscape]: { width: 3500, height: 2500 },
}
